import React, { ReactNode } from "react";

import { ArticleHeroBlock as Value } from "@reactivated";

import { HeroLayoutSettings } from "@thelabnyc/thelabui/src/components/Flexihero/HeroLayout.interfaces";
import { HeroSet } from "@thelabnyc/thelabui/src/components/Flexihero/HeroSet";

import { Themed } from "../../styles/themes";
import { Clickable } from "../Clickables";
import { MediaChooserBlock } from "../MediaChooserBlock";
import { RichText } from "../RichText";

import styles from "./index.module.scss";

interface Props {
    media: ReactNode | null;
    content: ReactNode | null;
}

const ArticleHero = ({ content, media }: Props) => {
    const sharedStyles = {
        contentClassName: styles.content,
        mediaClassName: styles.media,
    };

    const settings: HeroLayoutSettings = {
        heroDirection: "row",
        heroPlacement: "container",
        mediaPlacement: media ? "inline" : "none",
        mediaAspectRatio: "1:1",
        contentAlignPrimary: "middle",
        contentAlignSecondary: "left/top",
        textAlignment: "left",
        contentWidth: media ? 6 : 12,
    };

    return (
        <HeroSet
            layouts={{
                desktop: {
                    content,
                    media,
                    settings,
                    styles: sharedStyles,
                },
                mobile: {
                    content,
                    media,
                    settings: {
                        ...settings,
                        heroDirection: "column",
                        heroPlacement: "full",
                        contentAlignSecondary: "left/top",
                        contentWidth: 12,
                        textAlignment: "center",
                    },
                    styles: sharedStyles,
                },
            }}
        />
    );
};

interface ArticleHeroBlockProps {
    value: Value;
    parentPage?: { [k: string]: string };
}

export const ArticleHeroBlock = ({
    value,
    parentPage,
}: ArticleHeroBlockProps) => {
    const hasMedia = value.media && value.media.length > 0;

    return (
        <Themed
            theme="robinsBlue"
            className={hasMedia ? styles.withMedia : styles.withoutMedia}
        >
            <ArticleHero
                content={
                    value.content ? (
                        <>
                            {parentPage &&
                                value.back_link &&
                                value.back_link !== "none" && (
                                    <Clickable
                                        className={styles.backLink}
                                        href={parentPage.url}
                                        icon="arrow"
                                    >
                                        {parentPage.title}
                                    </Clickable>
                                )}
                            <RichText
                                value={value.content}
                                textAlignment={hasMedia ? "left" : "center"}
                                className={styles.richText}
                                constrainParagraphWidth={
                                    !hasMedia ? "half" : null
                                }
                            />
                        </>
                    ) : null
                }
                media={
                    hasMedia ? <MediaChooserBlock value={value.media!} /> : null
                }
            />
        </Themed>
    );
};
